// Skirmshop Chatbot — Vanilla JS
// Handles: SSE streaming chat, multi-session sidebar, welcome screen, order cards,
// inline product cards (data from backend), AJAX Cart API, tool_calls, UI
// Security: All DOM updates use textContent/createElement — no innerHTML with untrusted data
(function () {
  'use strict';

  var config = window.__SKIRMSHOP_CHATBOT_CONFIG || {};
  var API_URL = config.apiUrl || '';
  var CUSTOMER = config.customer || null;

  // ─── Language Detection ───
  function detectLocale() {
    if (config.locale) return config.locale;
    var htmlLang = document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    var pathMatch = window.location.pathname.match(/^\/(en|fr|de|it|pt|es)\//);
    if (pathMatch) return pathMatch[1];
    return 'en';
  }
  var LOCALE = detectLocale();
  var lang = LOCALE.slice(0, 2);

  // ─── Locale → Flag mapping ───
  var localeFlags = {
    en: '🇬🇧', es: '🇪🇸', fr: '🇫🇷', de: '🇩🇪', it: '🇮🇹', pt: '🇵🇹',
    nl: '🇳🇱', pl: '🇵🇱', sv: '🇸🇪', ja: '🇯🇵', zh: '🇨🇳', el: '🇬🇷',
    cs: '🇨🇿', hu: '🇭🇺', ro: '🇷🇴', bg: '🇧🇬', hr: '🇭🇷', uk: '🇺🇦',
    ru: '🇷🇺', tr: '🇹🇷', ca: '🏴'
  };

  // ─── i18n ───
  var i18n = {
    es: {
      capabilities: [
        'Rastrear pedidos y envíos',
        'Upgrades para tu réplica',
        'Consultar stock y disponibilidad',
        'Consejos de builds y ghillies',
        'Monta tu loadout completo paso a paso'
      ],
      chips: ['Ver mi último pedido', 'Upgrades para mi SRS', 'Cómo mejorar mi ghillie', 'Monta mi equipo completo'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Anadir',
      soldOut: 'Agotado',
      view: 'Ver',
      addedToCart: 'Anadido al carrito',
      cartError: 'Error al anadir al carrito',
      suggestionOk: 'Sugerencia registrada. Gracias!',
      suggestionError: 'No se pudo enviar la sugerencia.',
      noOrders: 'No tienes pedidos recientes o no has iniciado sesion.',
      serviceError: 'Lo siento, el servicio no esta disponible en este momento. Intentalo de nuevo.',
      rename: 'Renombrar',
      del: 'Eliminar',
      total: 'Total',
      trackingNumber: 'Seguimiento',
      viewOrder: 'Ver pedido',
      items: 'articulos',
      browse: 'Explorar',
      products: 'productos',
      cart: 'Carrito',
      cartEmpty: 'Tu carrito está vacío.',
      removeFromCart: 'Eliminado del carrito',
      cartUpdated: 'Carrito actualizado',
      cartCleared: 'Carrito vaciado',
      checkout: 'Finalizar compra',
      wishlist: 'Lista de Deseos', wishlistEmpty: 'Tu lista de deseos está vacía.', savedToWishlist: 'Guardado en tu lista de deseos', removedFromWishlist: 'Eliminado de tu lista de deseos', stockAlerts: 'Alertas de Stock', noAlerts: 'No tienes alertas de stock activas.', alertActivated: 'Alerta de stock activada', alertCancelled: 'Alerta cancelada', waiting: 'Esperando...', stockAvailable: 'Disponible!',
      shipping: 'Envío', noShipping: 'No hay envíos disponibles.', freeShipping: 'Envío gratis a partir de 100€', discountsTitle: 'Descuentos Activos', noDiscounts: 'No hay descuentos activos.', comparison: 'Comparación', returnTitle: 'Devolución', units: 'uds', days: 'días',
    },
    en: {
      capabilities: [
        'Track your orders and shipments',
        'Find upgrades for your replica',
        'Check stock and availability',
        'Expert advice on builds and ghillies',
        'Build your complete loadout step by step'
      ],
      chips: ['Check my last order', 'SRS upgrade parts', 'How to improve my ghillie', 'Build my loadout'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Add',
      soldOut: 'Sold out',
      view: 'View',
      addedToCart: 'Added to cart',
      cartError: 'Error adding to cart',
      suggestionOk: 'Suggestion recorded. Thank you!',
      suggestionError: 'Could not submit suggestion.',
      noOrders: 'No recent orders or not logged in.',
      serviceError: 'Sorry, the service is currently unavailable. Please try again.',
      rename: 'Rename',
      del: 'Delete',
      total: 'Total',
      trackingNumber: 'Tracking',
      viewOrder: 'View order',
      items: 'items',
      browse: 'Browse',
      products: 'products',
      cart: 'Cart',
      cartEmpty: 'Your cart is empty.',
      removeFromCart: 'Removed from cart',
      cartUpdated: 'Cart updated',
      cartCleared: 'Cart cleared',
      checkout: 'Checkout',
      wishlist: 'Wishlist', wishlistEmpty: 'Your wishlist is empty.', savedToWishlist: 'Saved to wishlist', removedFromWishlist: 'Removed from wishlist', stockAlerts: 'Stock Alerts', noAlerts: 'You have no active stock alerts.', alertActivated: 'Stock alert activated', alertCancelled: 'Alert cancelled', waiting: 'Waiting...', stockAvailable: 'Available!',
      shipping: 'Shipping', noShipping: 'No shipping methods available.', freeShipping: 'Free shipping over €100', discountsTitle: 'Active Discounts', noDiscounts: 'No active discount codes.', comparison: 'Product Comparison', returnTitle: 'Return', units: 'units', days: 'days',
    },
    fr: {
      capabilities: [
        'Suivre vos commandes et livraisons',
        'Trouver des upgrades pour votre réplique',
        'Vérifier le stock et la disponibilité',
        'Conseils sur les builds et les ghillies',
        'Montez votre équipement complet étape par étape'
      ],
      chips: ['Voir ma dernière commande', 'Upgrades pour mon SRS', 'Comment améliorer ma ghillie', 'Monte mon équipement'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Ajouter',
      soldOut: 'Épuisé',
      view: 'Voir',
      addedToCart: 'Ajouté au panier',
      cartError: 'Erreur lors de l\'ajout au panier',
      suggestionOk: 'Suggestion enregistrée. Merci !',
      suggestionError: 'Impossible d\'envoyer la suggestion.',
      noOrders: 'Aucune commande récente ou non connecté.',
      serviceError: 'Désolé, le service est temporairement indisponible. Veuillez réessayer.',
      rename: 'Renommer',
      del: 'Supprimer',
      total: 'Total',
      trackingNumber: 'Suivi',
      viewOrder: 'Voir commande',
      items: 'articles',
      browse: 'Parcourir',
      products: 'produits',
      cart: 'Panier',
      cartEmpty: 'Votre panier est vide.',
      removeFromCart: 'Retiré du panier',
      cartUpdated: 'Panier mis à jour',
      cartCleared: 'Panier vidé',
      checkout: 'Passer la commande',
      wishlist: 'Liste de souhaits', wishlistEmpty: 'Votre liste de souhaits est vide.', savedToWishlist: 'Ajouté à la liste', removedFromWishlist: 'Retiré de la liste', stockAlerts: 'Alertes de stock', noAlerts: 'Aucune alerte active.', alertActivated: 'Alerte activée', alertCancelled: 'Alerte annulée', waiting: 'En attente...', stockAvailable: 'Disponible !',
      shipping: 'Livraison', noShipping: 'Aucune méthode disponible.', freeShipping: 'Livraison gratuite dès 100€', discountsTitle: 'Réductions actives', noDiscounts: 'Aucune réduction active.', comparison: 'Comparaison', returnTitle: 'Retour', units: 'unités', days: 'jours',
    },
    de: {
      capabilities: [
        'Bestellungen und Sendungen verfolgen',
        'Upgrades für deine Replik finden',
        'Verfügbarkeit und Lagerbestand prüfen',
        'Expertenberatung zu Builds und Ghillies',
        'Stelle deine komplette Ausrüstung Schritt für Schritt zusammen'
      ],
      chips: ['Meine letzte Bestellung', 'SRS Upgrade-Teile', 'Wie verbessere ich meine Ghillie', 'Stelle meine Ausrüstung zusammen'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Hinzufügen',
      soldOut: 'Ausverkauft',
      view: 'Ansehen',
      addedToCart: 'Zum Warenkorb hinzugefügt',
      cartError: 'Fehler beim Hinzufügen zum Warenkorb',
      suggestionOk: 'Vorschlag gespeichert. Danke!',
      suggestionError: 'Vorschlag konnte nicht gesendet werden.',
      noOrders: 'Keine aktuellen Bestellungen oder nicht eingeloggt.',
      serviceError: 'Der Service ist vorübergehend nicht verfügbar. Bitte versuchen Sie es erneut.',
      rename: 'Umbenennen',
      del: 'Löschen',
      total: 'Gesamt',
      trackingNumber: 'Sendungsverfolgung',
      viewOrder: 'Bestellung ansehen',
      items: 'Artikel',
      browse: 'Durchsuchen',
      products: 'Produkte',
      cart: 'Warenkorb',
      cartEmpty: 'Dein Warenkorb ist leer.',
      removeFromCart: 'Aus dem Warenkorb entfernt',
      cartUpdated: 'Warenkorb aktualisiert',
      cartCleared: 'Warenkorb geleert',
      checkout: 'Zur Kasse',
      wishlist: 'Wunschliste', wishlistEmpty: 'Deine Wunschliste ist leer.', savedToWishlist: 'Zur Wunschliste hinzugefügt', removedFromWishlist: 'Von der Wunschliste entfernt', stockAlerts: 'Bestandsalarme', noAlerts: 'Keine aktiven Alarme.', alertActivated: 'Alarm aktiviert', alertCancelled: 'Alarm abgebrochen', waiting: 'Warten...', stockAvailable: 'Verfügbar!',
      shipping: 'Versand', noShipping: 'Keine Versandmethoden verfügbar.', freeShipping: 'Kostenloser Versand ab 100€', discountsTitle: 'Aktive Rabatte', noDiscounts: 'Keine aktiven Rabatte.', comparison: 'Produktvergleich', returnTitle: 'Rücksendung', units: 'Stk', days: 'Tage',
    },
    it: {
      capabilities: [
        'Tracciare ordini e spedizioni',
        'Trovare upgrade per la tua replica',
        'Verificare stock e disponibilità',
        'Consigli su build e ghillie',
        'Assembla il tuo equipaggiamento completo passo dopo passo'
      ],
      chips: ['Vedi il mio ultimo ordine', 'Upgrade per il mio SRS', 'Come migliorare la mia ghillie', 'Assembla il mio equipaggiamento'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Aggiungi',
      soldOut: 'Esaurito',
      view: 'Vedi',
      addedToCart: 'Aggiunto al carrello',
      cartError: 'Errore nell\'aggiunta al carrello',
      suggestionOk: 'Suggerimento registrato. Grazie!',
      suggestionError: 'Impossibile inviare il suggerimento.',
      noOrders: 'Nessun ordine recente o non hai effettuato l\'accesso.',
      serviceError: 'Spiacenti, il servizio non è al momento disponibile. Riprova.',
      rename: 'Rinomina',
      del: 'Elimina',
      total: 'Totale',
      trackingNumber: 'Tracciamento',
      viewOrder: 'Vedi ordine',
      items: 'articoli',
      browse: 'Sfoglia',
      products: 'prodotti',
      cart: 'Carrello',
      cartEmpty: 'Il tuo carrello è vuoto.',
      removeFromCart: 'Rimosso dal carrello',
      cartUpdated: 'Carrello aggiornato',
      cartCleared: 'Carrello svuotato',
      checkout: 'Vai al checkout',
      wishlist: 'Lista dei desideri', wishlistEmpty: 'La tua lista è vuota.', savedToWishlist: 'Aggiunto alla lista', removedFromWishlist: 'Rimosso dalla lista', stockAlerts: 'Avvisi di stock', noAlerts: 'Nessun avviso attivo.', alertActivated: 'Avviso attivato', alertCancelled: 'Avviso annullato', waiting: 'In attesa...', stockAvailable: 'Disponibile!',
      shipping: 'Spedizione', noShipping: 'Nessun metodo disponibile.', freeShipping: 'Spedizione gratuita oltre 100€', discountsTitle: 'Sconti attivi', noDiscounts: 'Nessuno sconto attivo.', comparison: 'Confronto prodotti', returnTitle: 'Reso', units: 'unità', days: 'giorni',
    },
    pt: {
      capabilities: [
        'Rastrear encomendas e envios',
        'Encontrar upgrades para a sua réplica',
        'Verificar stock e disponibilidade',
        'Conselhos sobre builds e ghillies',
        'Monte o seu equipamento completo passo a passo'
      ],
      chips: ['Ver a minha última encomenda', 'Upgrades para o meu SRS', 'Como melhorar a minha ghillie', 'Montar o meu equipamento'],
      capIcons: ['📦', '🔧', '📋', '💡', '🎯'],
      add: 'Adicionar',
      soldOut: 'Esgotado',
      view: 'Ver',
      addedToCart: 'Adicionado ao carrinho',
      cartError: 'Erro ao adicionar ao carrinho',
      suggestionOk: 'Sugestão registada. Obrigado!',
      suggestionError: 'Não foi possível enviar a sugestão.',
      noOrders: 'Sem encomendas recentes ou sessão não iniciada.',
      serviceError: 'Desculpe, o serviço está temporariamente indisponível. Tente novamente.',
      rename: 'Renomear',
      del: 'Eliminar',
      total: 'Total',
      trackingNumber: 'Rastreamento',
      viewOrder: 'Ver encomenda',
      items: 'artigos',
      browse: 'Explorar',
      products: 'produtos',
      cart: 'Carrinho',
      cartEmpty: 'O seu carrinho está vazio.',
      removeFromCart: 'Removido do carrinho',
      cartUpdated: 'Carrinho atualizado',
      cartCleared: 'Carrinho esvaziado',
      checkout: 'Finalizar compra',
      wishlist: 'Lista de desejos', wishlistEmpty: 'A sua lista está vazia.', savedToWishlist: 'Adicionado à lista', removedFromWishlist: 'Removido da lista', stockAlerts: 'Alertas de stock', noAlerts: 'Sem alertas ativas.', alertActivated: 'Alerta ativado', alertCancelled: 'Alerta cancelado', waiting: 'A aguardar...', stockAvailable: 'Disponível!',
      shipping: 'Envio', noShipping: 'Sem métodos disponíveis.', freeShipping: 'Envio grátis acima de 100€', discountsTitle: 'Descontos ativos', noDiscounts: 'Sem descontos ativos.', comparison: 'Comparação', returnTitle: 'Devolução', units: 'unidades', days: 'dias',
    }
  };
  var t = i18n[lang] || i18n.en;

  // ─── Tool Text Stripping ───
  function stripToolCalls(text) {
    return text.replace(/\[TOOL:[^\]]*\]/g, '').replace(/  +/g, ' ').trim();
  }

  function ensureAccountLinks(text) {
    if (/\/account\/login/i.test(text)) return text;
    if (!/(log\s*in|login|sign\s*in|inicia\s+sesion|iniciar\s+sesion|connectez-vous|connexion|anmelden|accedi|entrar)/i.test(text)) return text;
    if (String(lang || LOCALE || '').toLowerCase().indexOf('es') === 0) {
      return text + '\n\nLogin: https://skirmshop.es/account/login\nCrear cuenta: https://skirmshop.es/account/register';
    }
    return text + '\n\nLog in: https://skirmshop.es/account/login\nCreate account: https://skirmshop.es/account/register';
  }

  // ─── Markdown → HTML for bot messages ───
  function escapeHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function linkifyEscapedText(str) {
    return str.replace(/(https?:\/\/[^\s<]+)/g, function(url) {
      var cleanUrl = url.replace(/[.,;:!?)]$/, '');
      var suffix = url.slice(cleanUrl.length);
      return '<a href="' + cleanUrl + '" target="_blank" rel="noopener noreferrer">' + cleanUrl + '</a>' + suffix;
    });
  }

  function formatBotMessage(raw) {
    var text = ensureAccountLinks(stripToolCalls(raw));
    if (!text) return '';
    var escaped = escapeHtml(text);
    // Bold: **text**
    escaped = escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Italic: *text* (but not inside bold)
    escaped = escaped.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
    escaped = linkifyEscapedText(escaped);

    // Split into lines for list processing
    var lines = escaped.split('\n');
    var html = [];
    var inUl = false;
    var inOl = false;

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      var ulMatch = line.match(/^[-•]\s+(.+)/);
      var olMatch = line.match(/^\d+[.)]\s+(.+)/);

      if (ulMatch) {
        if (!inUl) { if (inOl) { html.push('</ol>'); inOl = false; } html.push('<ul>'); inUl = true; }
        html.push('<li>' + ulMatch[1] + '</li>');
      } else if (olMatch) {
        if (!inOl) { if (inUl) { html.push('</ul>'); inUl = false; } html.push('<ol>'); inOl = true; }
        html.push('<li>' + olMatch[1] + '</li>');
      } else {
        if (inUl) { html.push('</ul>'); inUl = false; }
        if (inOl) { html.push('</ol>'); inOl = false; }
        if (line === '') {
          html.push('<br>');
        } else {
          html.push('<p>' + line + '</p>');
        }
      }
    }
    if (inUl) html.push('</ul>');
    if (inOl) html.push('</ol>');

    return html.join('');
  }

  // ─── State ───
  var currentSessionId = null;
  var sessions = [];
  var chatHistory = []; // in-memory history for current session
  var sending = false;
  var sidebarCollapsed = false;

  // ─── DOM ───
  var messagesEl = document.getElementById('ChatbotMessages');
  var messagesInner = document.getElementById('ChatbotMessagesInner');
  var inputEl = document.getElementById('ChatbotInput');
  var sendBtn = document.getElementById('ChatbotSend');
  var checkoutPanel = document.getElementById('ChatbotCheckout');
  var toastEl = document.getElementById('ChatbotToast');
  var welcomeEl = document.getElementById('ChatbotWelcome');
  var welcomeList = document.getElementById('ChatbotWelcomeList');
  var welcomeChips = document.getElementById('ChatbotWelcomeChips');
  var sessionList = document.getElementById('ChatbotSessionList');
  var sidebarEl = document.getElementById('ChatbotSidebar');
  var sidebarOverlay = document.getElementById('ChatbotSidebarOverlay');
  var sidebarToggle = document.getElementById('ChatbotSidebarToggle');
  var newSessionSidebar = document.getElementById('ChatbotNewSession');
  var newSessionBtn = document.getElementById('ChatbotNewSessionBtn');
  var langBtn = document.getElementById('ChatbotLangBtn');
  var langDropdown = document.getElementById('ChatbotLangDropdown');

  // ─── Language Selector ───
  var availableLocales = (config.locales || ['es']).map(function (l) { return l.slice(0, 2); });
  // Deduplicate (pt-PT → pt)
  availableLocales = availableLocales.filter(function (v, i, a) { return a.indexOf(v) === i; });

  function updateLangButton() {
    if (langBtn) langBtn.textContent = localeFlags[lang] || '🌐';
  }
  updateLangButton();

  function buildLangDropdown() {
    if (!langDropdown) return;
    langDropdown.innerHTML = '';
    availableLocales.forEach(function (loc) {
      var opt = document.createElement('button');
      opt.className = 'chatbot-lang-option' + (loc === lang ? ' is-active' : '');
      opt.textContent = localeFlags[loc] || loc.toUpperCase();
      opt.title = loc.toUpperCase();
      opt.setAttribute('data-lang', loc);
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        selectLanguage(loc);
      });
      langDropdown.appendChild(opt);
    });
  }
  buildLangDropdown();

  if (langBtn) {
    langBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      langDropdown.classList.toggle('is-open');
    });
  }
  // Close dropdown on outside click
  document.addEventListener('click', function () {
    if (langDropdown) langDropdown.classList.remove('is-open');
  });

  function selectLanguage(newLang) {
    if (newLang === lang) {
      langDropdown.classList.remove('is-open');
      return;
    }
    lang = newLang;
    LOCALE = newLang;
    t = i18n[lang] || i18n.en;
    updateLangButton();
    buildLangDropdown();
    langDropdown.classList.remove('is-open');
    // Retranslate the last bot message
    retranslateLastBotMessage();
  }

  function retranslateLastBotMessage() {
    if (!messagesInner) return;
    // Find the last bot message bubble
    var botMsgs = messagesInner.querySelectorAll('.chatbot-msg--bot');
    if (botMsgs.length === 0) return;
    var lastBotBubble = botMsgs[botMsgs.length - 1];
    // Get the raw text from chat history
    var lastBotText = '';
    for (var i = chatHistory.length - 1; i >= 0; i--) {
      if (chatHistory[i].role === 'assistant') {
        lastBotText = chatHistory[i].content;
        break;
      }
    }
    if (!lastBotText || lastBotText === '[products shown]') return;
    // Send a translate request (no sessionId — don't persist in history)
    lastBotBubble.innerHTML = '<em style="opacity:0.6">Translating...</em>';
    var body = {
      message: 'Translate your previous response to ' + lang.toUpperCase() + '. Keep the same content and formatting, just change the language.',
      history: chatHistory.slice(-20),
      context: { customer: CUSTOMER, cartItems: [], locale: LOCALE },
    };
    fetch(API_URL + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error('translate failed');
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var translatedText = '';
      function pump() {
        return reader.read().then(function (result) {
          if (result.done) {
            if (translatedText) {
              lastBotBubble.innerHTML = formatBotMessage(translatedText);
              // Update chat history
              for (var j = chatHistory.length - 1; j >= 0; j--) {
                if (chatHistory[j].role === 'assistant') {
                  chatHistory[j].content = translatedText;
                  break;
                }
              }
            }
            return;
          }
          buffer += decoder.decode(result.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (var k = 0; k < lines.length; k++) {
            var line = lines[k];
            if (line.indexOf('data: ') === 0) {
              try {
                var data = JSON.parse(line.slice(6));
                if (data.text && !data.tool) {
                  translatedText += data.text;
                  lastBotBubble.innerHTML = formatBotMessage(translatedText);
                }
              } catch (e) {}
            }
          }
          return pump();
        });
      }
      return pump();
    }).catch(function () {
      lastBotBubble.innerHTML = formatBotMessage(lastBotText);
    });
  }

  // ─── Session API ───

  function apiCreateSession() {
    if (!CUSTOMER || !CUSTOMER.email) return Promise.resolve(null);
    return fetch(API_URL + '/sessions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: CUSTOMER.email }),
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function apiListSessions() {
    if (!CUSTOMER || !CUSTOMER.email) return Promise.resolve([]);
    return fetch(API_URL + '/sessions?email=' + encodeURIComponent(CUSTOMER.email))
      .then(function (r) { return r.ok ? r.json() : []; })
      .catch(function () { return []; });
  }

  function apiLoadSession(id) {
    return fetch(API_URL + '/sessions/' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function apiDeleteSession(id) {
    return fetch(API_URL + '/sessions/' + encodeURIComponent(id), { method: 'DELETE' })
      .then(function (r) { return r.ok; })
      .catch(function () { return false; });
  }

  function apiRenameSession(id, title) {
    return fetch(API_URL + '/sessions/' + encodeURIComponent(id), {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: title }),
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // ─── Sidebar Rendering ───

  function renderSidebar() {
    if (!sessionList) return;
    while (sessionList.firstChild) sessionList.removeChild(sessionList.firstChild);

    sessions.forEach(function (s) {
      var item = document.createElement('div');
      item.className = 'chatbot-sidebar-item' + (s.id === currentSessionId ? ' is-active' : '');
      item.setAttribute('data-id', s.id);

      var titleEl = document.createElement('div');
      titleEl.className = 'chatbot-sidebar-item-title';
      titleEl.textContent = s.title || 'New Chat';
      item.appendChild(titleEl);

      var dateEl = document.createElement('div');
      dateEl.className = 'chatbot-sidebar-item-date';
      var d = new Date(s.updatedAt);
      dateEl.textContent = d.toLocaleDateString(LOCALE, { month: 'short', day: 'numeric' });
      item.appendChild(dateEl);

      var actions = document.createElement('div');
      actions.className = 'chatbot-sidebar-item-actions';

      var renameBtn = document.createElement('button');
      renameBtn.className = 'chatbot-sidebar-item-btn';
      renameBtn.textContent = t.rename;
      (function (sid) {
        renameBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var newTitle = prompt('', titleEl.textContent);
          if (newTitle && newTitle.trim()) {
            apiRenameSession(sid, newTitle.trim()).then(function () {
              titleEl.textContent = newTitle.trim();
              var session = sessions.find(function (ss) { return ss.id === sid; });
              if (session) session.title = newTitle.trim();
            });
          }
        });
      })(s.id);
      actions.appendChild(renameBtn);

      var delBtn = document.createElement('button');
      delBtn.className = 'chatbot-sidebar-item-btn delete';
      delBtn.textContent = t.del;
      (function (sid) {
        delBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          apiDeleteSession(sid).then(function (ok) {
            if (ok) {
              sessions = sessions.filter(function (ss) { return ss.id !== sid; });
              if (currentSessionId === sid) {
                if (sessions.length > 0) {
                  switchSession(sessions[0].id);
                } else {
                  createNewSession();
                }
              }
              renderSidebar();
            }
          });
        });
      })(s.id);
      actions.appendChild(delBtn);

      item.appendChild(actions);

      (function (sid) {
        item.addEventListener('click', function () {
          if (sid !== currentSessionId) switchSession(sid);
          closeMobileSidebar();
        });
      })(s.id);

      sessionList.appendChild(item);
    });
  }

  // ─── Session Switching ───

  function switchSession(id) {
    currentSessionId = id;
    chatHistory = [];
    clearMessages();

    // Mark active in sidebar
    renderSidebar();

    apiLoadSession(id).then(function (data) {
      if (!data || !data.messages || data.messages.length === 0) {
        showWelcome();
        return;
      }
      hideWelcome();
      data.messages.forEach(function (msg) {
        if (msg.role === 'user') {
          appendMessage('user', msg.content);
          chatHistory.push({ role: 'user', content: msg.content });
        } else {
          appendMessage('bot', stripToolCalls(msg.content));
          chatHistory.push({ role: 'assistant', content: msg.content });
          // Re-render tool calls (products, collections, orders) from persisted data
          if (msg.toolCalls) {
            try {
              var tools = JSON.parse(msg.toolCalls);
              var products = [];
              var collections = [];
              for (var ti = 0; ti < tools.length; ti++) {
                var tc = tools[ti];
                if (tc.tool === 'show_product' && tc.product) {
                  products.push(tc);
                } else if (tc.tool === 'show_collection' && tc.collection) {
                  collections.push(tc);
                } else if (tc.tool === 'show_orders' && tc.orders) {
                  renderOrderList(tc.orders);
                } else if (tc.tool === 'show_order_status' && tc.order) {
                  messagesInner.appendChild(renderOrderCard(tc.order));
                }
              }
              if (products.length > 0) renderProductGrid(products);
              if (collections.length > 0) renderCollectionGrid(collections);
            } catch (e) { /* skip malformed toolCalls */ }
          }
        }
      });
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  }

  function createNewSession() {
    apiCreateSession().then(function (session) {
      if (session) {
        sessions.unshift({ id: session.id, title: session.title, updatedAt: session.updatedAt });
        currentSessionId = session.id;
        chatHistory = [];
        clearMessages();
        showWelcome();
        renderSidebar();
      }
    });
  }

  // ─── Welcome Screen ───

  function showWelcome() {
    if (!welcomeEl) return;
    // Populate capabilities
    if (welcomeList) {
      while (welcomeList.firstChild) welcomeList.removeChild(welcomeList.firstChild);
      t.capabilities.forEach(function (cap, i) {
        var li = document.createElement('li');
        var icon = document.createElement('span');
        icon.className = 'icon';
        icon.textContent = t.capIcons[i] || '•';
        li.appendChild(icon);
        var text = document.createElement('span');
        text.textContent = cap;
        li.appendChild(text);
        welcomeList.appendChild(li);
      });
    }
    // Populate chips
    if (welcomeChips) {
      while (welcomeChips.firstChild) welcomeChips.removeChild(welcomeChips.firstChild);
      t.chips.forEach(function (chipText) {
        var chip = document.createElement('button');
        chip.className = 'chatbot-welcome-chip';
        chip.textContent = chipText;
        chip.addEventListener('click', function () {
          inputEl.value = chipText;
          sendMessage();
        });
        welcomeChips.appendChild(chip);
      });
    }
    welcomeEl.style.display = '';
    if (messagesEl) messagesEl.style.display = 'none';
  }

  function hideWelcome() {
    if (welcomeEl) welcomeEl.style.display = 'none';
    if (messagesEl) messagesEl.style.display = '';
  }

  // ─── Mobile Sidebar ───

  function openMobileSidebar() {
    if (sidebarEl) sidebarEl.classList.add('is-open');
    if (sidebarOverlay) sidebarOverlay.classList.add('is-visible');
  }

  function closeMobileSidebar() {
    if (sidebarEl) sidebarEl.classList.remove('is-open');
    if (sidebarOverlay) sidebarOverlay.classList.remove('is-visible');
  }

  function toggleDesktopSidebar() {
    sidebarCollapsed = !sidebarCollapsed;
    if (sidebarEl) sidebarEl.classList.toggle('is-collapsed', sidebarCollapsed);
    var container = document.getElementById('ChatbotApp');
    if (container) container.classList.toggle('sidebar-collapsed', sidebarCollapsed);
  }

  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', function () {
      if (window.innerWidth > 767) {
        toggleDesktopSidebar();
      } else {
        openMobileSidebar();
      }
    });
  }
  if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeMobileSidebar);

  // ─── New session buttons ───
  if (newSessionSidebar) newSessionSidebar.addEventListener('click', createNewSession);
  if (newSessionBtn) newSessionBtn.addEventListener('click', createNewSession);

  // ─── AJAX Cart API (same-domain, no token needed) ───

  function addToCart(variantId) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        showToast(t.addedToCart);
        refreshCart();
      })
      .catch(function () {
        showToast(t.cartError);
      });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCheckoutPanel(cart);
      })
      .catch(function () { });
  }

  // ─── Inline Product Cards (rendered from backend data) ───

  function createFailedToolCard(handle) {
    var card = document.createElement('div');
    card.className = 'chatbot-failed-tool';

    var header = document.createElement('div');
    header.className = 'chatbot-failed-tool-header';

    var badge = document.createElement('span');
    badge.className = 'chatbot-failed-tool-badge';
    badge.textContent = lang === 'en' ? 'Failed' : 'Error';
    header.appendChild(badge);

    var toggle = document.createElement('button');
    toggle.className = 'chatbot-failed-tool-toggle';
    toggle.textContent = '\u25B8';
    header.appendChild(toggle);

    var details = document.createElement('div');
    details.className = 'chatbot-failed-tool-details';
    details.style.display = 'none';
    details.textContent = handle;

    toggle.addEventListener('click', function () {
      if (details.style.display === 'none') {
        details.style.display = 'block';
        toggle.textContent = '\u25BE';
      } else {
        details.style.display = 'none';
        toggle.textContent = '\u25B8';
      }
    });

    card.appendChild(header);
    card.appendChild(details);
    return card;
  }

  function renderProductGrid(products) {
    var grid = document.createElement('div');
    grid.className = 'chatbot-product-grid';

    products.forEach(function (item) {
      if (!item.product) {
        grid.appendChild(createFailedToolCard(item.handle || 'unknown'));
        return;
      }
      var card = createProductCard(item.product);
      grid.appendChild(card);
    });

    if (grid.children.length > 0) {
      messagesInner.appendChild(grid);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }
  }

  function createProductCard(product) {
    var card = document.createElement('div');
    card.className = 'chatbot-inline-card';

    // Image slider
    var images = product.images && product.images.length > 0 ? product.images : (product.image ? [product.image] : []);
    var sliderWrap = document.createElement('div');
    sliderWrap.className = 'chatbot-card-slider';

    var sliderTrack = document.createElement('div');
    sliderTrack.className = 'chatbot-card-slider-track';
    var currentIdx = 0;

    images.forEach(function (url, i) {
      var slide = document.createElement('div');
      slide.className = 'chatbot-card-slide';
      var img = document.createElement('img');
      img.src = url;
      img.alt = product.title + (i > 0 ? ' (' + (i + 1) + ')' : '');
      img.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      sliderTrack.appendChild(slide);
    });

    sliderWrap.appendChild(sliderTrack);

    if (images.length > 1) {
      var prevBtn = document.createElement('button');
      prevBtn.className = 'chatbot-slider-btn chatbot-slider-prev';
      prevBtn.innerHTML = '&#8249;';
      prevBtn.setAttribute('aria-label', 'Previous image');
      var nextBtn = document.createElement('button');
      nextBtn.className = 'chatbot-slider-btn chatbot-slider-next';
      nextBtn.innerHTML = '&#8250;';
      nextBtn.setAttribute('aria-label', 'Next image');

      var dots = document.createElement('div');
      dots.className = 'chatbot-slider-dots';
      images.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'chatbot-slider-dot' + (i === 0 ? ' active' : '');
        dots.appendChild(dot);
      });

      function goToSlide(idx) {
        if (idx < 0) idx = images.length - 1;
        if (idx >= images.length) idx = 0;
        currentIdx = idx;
        sliderTrack.style.transform = 'translateX(-' + (idx * 100) + '%)';
        var allDots = dots.querySelectorAll('.chatbot-slider-dot');
        for (var d = 0; d < allDots.length; d++) {
          allDots[d].className = 'chatbot-slider-dot' + (d === idx ? ' active' : '');
        }
      }

      prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goToSlide(currentIdx - 1); });
      nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goToSlide(currentIdx + 1); });

      sliderWrap.appendChild(prevBtn);
      sliderWrap.appendChild(nextBtn);
      sliderWrap.appendChild(dots);
    }

    card.appendChild(sliderWrap);

    // Info
    var info = document.createElement('div');
    info.className = 'chatbot-inline-card-info';

    var title = document.createElement('a');
    title.href = '/products/' + product.handle;
    title.target = '_blank';
    title.className = 'chatbot-inline-card-title';
    title.textContent = product.title;
    info.appendChild(title);

    var priceEl = document.createElement('div');
    priceEl.className = 'chatbot-inline-card-price';
    priceEl.textContent = parseFloat(product.price).toFixed(2) + ' ' + (product.currency || 'EUR');
    info.appendChild(priceEl);

    // Stock indicator
    if (product.totalInventory !== undefined) {
      var stockEl = document.createElement('div');
      if (product.lowStock) {
        stockEl.className = 'chatbot-stock chatbot-stock--low';
        stockEl.textContent = '⚠️ ' + (lang === 'es' ? 'Solo quedan ' + product.totalInventory + '!' : 'Only ' + product.totalInventory + ' left!');
      } else if (!product.available) {
        stockEl.className = 'chatbot-stock chatbot-stock--out';
        stockEl.textContent = '❌ ' + (lang === 'es' ? 'Agotado' : t.soldOut);
      } else {
        stockEl.className = 'chatbot-stock chatbot-stock--ok';
        stockEl.textContent = '✅ ' + (lang === 'es' ? 'En stock' : 'In stock');
      }
      info.appendChild(stockEl);
    }

    // Description
    if (product.description) {
      var desc = document.createElement('div');
      desc.className = 'chatbot-inline-card-desc';
      desc.textContent = product.description;
      info.appendChild(desc);
    }

    card.appendChild(info);

    // Actions
    var actions = document.createElement('div');
    actions.className = 'chatbot-inline-card-actions';

    var addBtn = document.createElement('button');
    addBtn.className = 'chatbot-card-btn chatbot-card-btn-add';
    if (product.available && product.variantId) {
      addBtn.textContent = t.add;
      (function (vid) {
        addBtn.addEventListener('click', function () { addToCart(vid); });
      })(product.variantId);
    } else {
      addBtn.textContent = t.soldOut;
      addBtn.disabled = true;
    }
    actions.appendChild(addBtn);

    var viewBtn = document.createElement('a');
    viewBtn.href = '/products/' + product.handle;
    viewBtn.target = '_blank';
    viewBtn.className = 'chatbot-card-btn chatbot-card-btn-view';
    viewBtn.textContent = t.view;
    actions.appendChild(viewBtn);

    card.appendChild(actions);
    return card;
  }

  // ─── Collection Card Rendering ───

  function renderCollectionGrid(collections) {
    var grid = document.createElement('div');
    grid.className = 'chatbot-product-grid';

    collections.forEach(function (item) {
      if (!item.collection) {
        grid.appendChild(createFailedToolCard(item.handle || 'unknown'));
        return;
      }
      var card = createCollectionCard(item.collection);
      grid.appendChild(card);
    });

    if (grid.children.length > 0) {
      messagesInner.appendChild(grid);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }
  }

  function createCollectionCard(collection) {
    var card = document.createElement('div');
    card.className = 'chatbot-inline-card chatbot-collection-card';

    // Image
    var imgLink = document.createElement('a');
    imgLink.href = '/collections/' + collection.handle;
    imgLink.target = '_blank';
    imgLink.className = 'chatbot-card-img-link';
    var img = document.createElement('img');
    img.src = collection.image || '';
    img.alt = collection.title;
    img.loading = 'lazy';
    imgLink.appendChild(img);
    card.appendChild(imgLink);

    // Info
    var info = document.createElement('div');
    info.className = 'chatbot-inline-card-info';

    var title = document.createElement('a');
    title.href = '/collections/' + collection.handle;
    title.target = '_blank';
    title.className = 'chatbot-inline-card-title';
    title.textContent = collection.title;
    info.appendChild(title);

    var countEl = document.createElement('div');
    countEl.className = 'chatbot-inline-card-price';
    countEl.textContent = (collection.productsCount || 0) + ' ' + t.products;
    info.appendChild(countEl);

    card.appendChild(info);

    // Actions
    var actions = document.createElement('div');
    actions.className = 'chatbot-inline-card-actions';

    var browseBtn = document.createElement('a');
    browseBtn.href = '/collections/' + collection.handle;
    browseBtn.target = '_blank';
    browseBtn.className = 'chatbot-card-btn chatbot-card-btn-add';
    browseBtn.textContent = t.browse;
    actions.appendChild(browseBtn);

    card.appendChild(actions);
    return card;
  }

  // ─── Order Card Rendering ───

  function getOrderBadgeClass(status) {
    if (!status) return 'unfulfilled';
    var s = status.toLowerCase().replace(/ /g, '_');
    if (s === 'fulfilled' || s === 'delivered') return 'delivered';
    if (s === 'partial' || s === 'partially_fulfilled' || s === 'in_transit' || s === 'in_progress') return 'shipped';
    if (s === 'unfulfilled' || s === 'null') return 'unfulfilled';
    if (s === 'cancelled' || s === 'refunded' || s === 'restocked') return 'cancelled';
    if (s === 'on_hold' || s === 'pending_fulfillment') return 'processing';
    return 'processing';
  }

  function renderOrderCard(order) {
    var card = document.createElement('div');
    card.className = 'chatbot-order-card chatbot-order-collapsed';

    // Header (always visible — click to expand/collapse)
    var header = document.createElement('div');
    header.className = 'chatbot-order-header';
    var headerLeft = document.createElement('div');
    headerLeft.className = 'chatbot-order-header-left';
    var nameEl = document.createElement('span');
    nameEl.className = 'chatbot-order-name';
    nameEl.textContent = order.name || order.orderNumber || '';
    headerLeft.appendChild(nameEl);
    // Summary line: date + total (visible when collapsed)
    var summaryEl = document.createElement('span');
    summaryEl.className = 'chatbot-order-summary';
    var dateStr = order.createdAt ? new Date(order.createdAt).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
    var tp = order.totalPrice ? parseFloat(order.totalPrice) : 0;
    var cur = order.currency === 'EUR' || !order.currency ? '€' : order.currency + ' ';
    var totalStr = tp ? (cur + tp.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : '';
    var itemCount = order.lineItems ? order.lineItems.length : 0;
    summaryEl.textContent = dateStr + (totalStr ? ' · ' + totalStr : '') + (itemCount ? ' · ' + itemCount + ' ' + t.items : '');
    headerLeft.appendChild(summaryEl);
    header.appendChild(headerLeft);
    var headerRight = document.createElement('div');
    headerRight.className = 'chatbot-order-header-right';
    var badge = document.createElement('span');
    badge.className = 'chatbot-order-badge ' + getOrderBadgeClass(order.fulfillmentStatus);
    badge.textContent = order.fulfillmentStatus || 'unfulfilled';
    headerRight.appendChild(badge);
    var chevron = document.createElement('span');
    chevron.className = 'chatbot-order-chevron';
    chevron.textContent = '▸';
    headerRight.appendChild(chevron);
    header.appendChild(headerRight);
    card.appendChild(header);

    // Toggle expand/collapse
    header.addEventListener('click', function () {
      card.classList.toggle('chatbot-order-collapsed');
    });

    // Body (hidden when collapsed)
    var body = document.createElement('div');
    body.className = 'chatbot-order-body';

    // Tracking
    if (order.trackingNumbers && order.trackingNumbers.length > 0) {
      order.trackingNumbers.forEach(function (num, idx) {
        var tracking = document.createElement('div');
        tracking.className = 'chatbot-order-tracking';
        var company = (order.trackingCompanies && order.trackingCompanies[idx]) || '';
        var trackUrl = order.trackingUrls && order.trackingUrls[idx];
        // Carrier icon
        var iconWrap = document.createElement('div');
        iconWrap.className = 'chatbot-track-icon';
        iconWrap.textContent = '📦';
        tracking.appendChild(iconWrap);
        // Info column
        var infoCol = document.createElement('div');
        infoCol.className = 'chatbot-track-info';
        var numEl = document.createElement('div');
        numEl.className = 'chatbot-track-number';
        numEl.textContent = num;
        infoCol.appendChild(numEl);
        if (company) {
          var companyEl = document.createElement('div');
          companyEl.className = 'chatbot-track-company';
          companyEl.textContent = company;
          infoCol.appendChild(companyEl);
        }
        tracking.appendChild(infoCol);
        // Track button
        if (trackUrl) {
          var btn = document.createElement('a');
          btn.href = trackUrl;
          btn.target = '_blank';
          btn.rel = 'noopener';
          btn.className = 'chatbot-track-btn';
          btn.textContent = t.trackingNumber + ' ↗';
          tracking.appendChild(btn);
        }
        body.appendChild(tracking);
      });
    }

    // Line items
    if (order.lineItems && order.lineItems.length > 0) {
      var items = document.createElement('div');
      items.className = 'chatbot-order-items';
      order.lineItems.forEach(function (li) {
        // Clean up "Title - Variant" duplication from old imported orders
        var displayTitle = li.title || '';
        var displayVariant = li.variantTitle || '';
        if (!displayVariant && displayTitle.indexOf(' - ') > 0) {
          var splitIdx = displayTitle.indexOf(' - ');
          var part1 = displayTitle.substring(0, splitIdx).trim();
          var part2 = displayTitle.substring(splitIdx + 3).trim();
          if (part2 && part2 !== '-') {
            displayTitle = part1;
            displayVariant = part2;
          } else if (part2 === '' || part2 === '-') {
            displayTitle = part1;
          }
        }
        var line = document.createElement('div');
        line.className = 'chatbot-order-line';
        var productUrl = li.handle ? ('/products/' + li.handle) : '';
        // Image (clickable if product link available)
        var imgWrap = document.createElement('div');
        imgWrap.className = 'chatbot-order-line-img';
        if (li.image) {
          var lineImg = document.createElement('img');
          lineImg.src = li.image.replace(/\.([a-z]+)\?/, '_80x80.$1?');
          lineImg.alt = li.title || '';
          lineImg.loading = 'lazy';
          if (productUrl) {
            var imgLink = document.createElement('a');
            imgLink.href = productUrl;
            imgLink.target = '_blank';
            imgLink.appendChild(lineImg);
            imgWrap.appendChild(imgLink);
          } else {
            imgWrap.appendChild(lineImg);
          }
        } else {
          imgWrap.innerHTML = '<span class="chatbot-order-line-noimg">📦</span>';
        }
        line.appendChild(imgWrap);
        // Info (title + variant)
        var lineInfo = document.createElement('div');
        lineInfo.className = 'chatbot-order-line-info';
        if (productUrl) {
          var titleLink = document.createElement('a');
          titleLink.href = productUrl;
          titleLink.target = '_blank';
          titleLink.className = 'chatbot-order-line-title';
          titleLink.textContent = displayTitle;
          lineInfo.appendChild(titleLink);
        } else {
          var titleSpan = document.createElement('span');
          titleSpan.className = 'chatbot-order-line-title';
          titleSpan.textContent = displayTitle;
          lineInfo.appendChild(titleSpan);
        }
        if (displayVariant) {
          var varEl = document.createElement('span');
          varEl.className = 'chatbot-order-line-variant';
          varEl.textContent = displayVariant;
          lineInfo.appendChild(varEl);
        }
        line.appendChild(lineInfo);
        // Price + quantity
        var lineRight = document.createElement('div');
        lineRight.className = 'chatbot-order-line-right';
        if (li.price) {
          var priceEl = document.createElement('div');
          priceEl.className = 'chatbot-order-line-price';
          priceEl.textContent = '€' + parseFloat(li.price).toFixed(2);
          lineRight.appendChild(priceEl);
        }
        var lineQty = document.createElement('div');
        lineQty.className = 'chatbot-order-line-qty';
        lineQty.textContent = 'x' + (li.quantity || 1);
        lineRight.appendChild(lineQty);
        line.appendChild(lineRight);
        items.appendChild(line);
      });
      body.appendChild(items);
    }

    // Footer
    var footer = document.createElement('div');
    footer.className = 'chatbot-order-footer';
    var totalEl = document.createElement('span');
    totalEl.className = 'chatbot-order-total';
    totalEl.textContent = totalStr;
    footer.appendChild(totalEl);
    if (order.statusUrl) {
      var linkEl = document.createElement('a');
      linkEl.className = 'chatbot-order-link';
      linkEl.href = order.statusUrl;
      linkEl.target = '_blank';
      linkEl.textContent = t.viewOrder;
      footer.appendChild(linkEl);
    }
    body.appendChild(footer);

    card.appendChild(body);
    return card;
  }

  function renderOrderList(orders) {
    if (!orders || orders.length === 0) {
      appendMessage('bot', t.noOrders);
      return;
    }
    orders.forEach(function (order) {
      messagesInner.appendChild(renderOrderCard(order));
    });
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Cart Rendering ───

  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(cart) { cb(cart); })
      .catch(function() { cb(null); });
  }

  function renderCartCard(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      appendMessage('bot', t.cartEmpty);
      return;
    }
    var container = document.createElement('div');
    container.className = 'chatbot-cart';

    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.cart + ' (' + cart.item_count + ')';
    container.appendChild(header);

    cart.items.forEach(function(item) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = item.title;
        row.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      name.textContent = item.title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      meta.textContent = 'x' + item.quantity + ' · ' + (item.final_line_price / 100).toFixed(2) + ' EUR';
      info.appendChild(meta);
      row.appendChild(info);

      var removeBtn = document.createElement('button');
      removeBtn.className = 'chatbot-cart-remove';
      removeBtn.textContent = '×';
      removeBtn.title = t.remove || 'Remove';
      (function(key) {
        removeBtn.addEventListener('click', function() {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          }).then(function() {
            showToast(t.removeFromCart);
            fetchCart(function(updated) {
              if (container.parentNode) container.parentNode.removeChild(container);
              renderCartCard(updated);
            });
          });
        });
      })(item.key);
      row.appendChild(removeBtn);
      container.appendChild(row);
    });

    var footer = document.createElement('div');
    footer.className = 'chatbot-cart-footer';
    var total = document.createElement('span');
    total.textContent = t.total + ': ' + (cart.total_price / 100).toFixed(2) + ' EUR';
    footer.appendChild(total);
    var checkoutBtn = document.createElement('a');
    checkoutBtn.href = '/checkout';
    checkoutBtn.className = 'chatbot-cart-checkout';
    checkoutBtn.textContent = t.checkout + ' →';
    footer.appendChild(checkoutBtn);
    container.appendChild(footer);

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Wishlist Rendering ───
  function renderWishlistCard(items) {
    if (!items || items.length === 0) {
      appendMessage('bot', t.wishlistEmpty);
      return;
    }
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.wishlist + ' (' + items.length + ')';
    container.appendChild(header);

    items.forEach(function(item) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = item.productTitle;
        row.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      var link = document.createElement('a');
      link.href = '/products/' + item.productHandle;
      link.target = '_blank';
      link.textContent = item.productTitle;
      link.style.color = 'inherit';
      name.appendChild(link);
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      var price = item.currentPrice ? parseFloat(item.currentPrice).toFixed(2) + ' EUR' : '';
      var stock = item.available ? '✅ ' + (t.view || 'In stock') : '❌ ' + (t.soldOut || 'Out of stock');
      meta.textContent = price + (price ? ' · ' : '') + stock;
      info.appendChild(meta);
      row.appendChild(info);
      container.appendChild(row);
    });

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Stock Alert Rendering ───
  function renderStockAlerts(alerts) {
    if (!alerts || alerts.length === 0) {
      appendMessage('bot', t.noAlerts);
      return;
    }
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.stockAlerts + ' (' + alerts.length + ')';
    container.appendChild(header);

    alerts.forEach(function(alert) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';
      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      name.textContent = alert.productTitle;
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      var statusIcon = alert.status === 'notified' ? '✅' : '⏳';
      var statusText = alert.status === 'notified' ? t.stockAvailable : t.waiting;
      meta.textContent = statusIcon + ' ' + statusText;
      info.appendChild(meta);
      row.appendChild(info);
      container.appendChild(row);
    });

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Shipping Card ───
  function renderShippingCard(methods, country) {
    if (!methods || methods.length === 0) {
      appendMessage('bot', t.noShipping);
      return;
    }
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.shipping + ' → ' + (country || '').toUpperCase();
    container.appendChild(header);

    methods.forEach(function(m) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';
      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      name.textContent = m.carrier + ' — ' + m.name;
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      meta.textContent = parseFloat(m.price).toFixed(2) + ' EUR · ' + m.minDays + '-' + m.maxDays + ' ' + t.days;
      info.appendChild(meta);
      row.appendChild(info);
      container.appendChild(row);
    });

    var footer = document.createElement('div');
    footer.className = 'chatbot-cart-footer';
    var note = document.createElement('span');
    note.style.fontSize = '12px';
    note.style.color = '#888';
    note.textContent = t.freeShipping;
    footer.appendChild(note);
    container.appendChild(footer);

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Discount Card ───
  function renderDiscountCard(discounts) {
    if (!discounts || discounts.length === 0) {
      appendMessage('bot', t.noDiscounts);
      return;
    }
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.discountsTitle;
    container.appendChild(header);

    discounts.forEach(function(d) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';
      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      name.textContent = d.code + ' — ' + d.value + (d.type === 'percentage' ? ' off' : '');
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      var parts = [];
      if (d.title && d.title !== d.code) parts.push(d.title);
      if (d.minimumSubtotal) parts.push('Min: ' + d.minimumSubtotal + '€');
      if (d.endsAt) parts.push(new Date(d.endsAt).toLocaleDateString());
      meta.textContent = parts.join(' · ') || d.title;
      info.appendChild(meta);
      row.appendChild(info);
      container.appendChild(row);
    });

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Comparison Card ───
  function renderComparisonCard(products) {
    if (!products || products.length < 2) return;
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.comparison;
    container.appendChild(header);

    products.forEach(function(p) {
      var row = document.createElement('div');
      row.className = 'chatbot-cart-item';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image.replace(/(\.\w+)$/, '_small$1');
        img.alt = p.title;
        row.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'chatbot-cart-item-info';
      var name = document.createElement('div');
      name.className = 'chatbot-cart-item-name';
      var link = document.createElement('a');
      link.href = '/products/' + p.handle;
      link.target = '_blank';
      link.textContent = p.title;
      link.style.color = 'inherit';
      name.appendChild(link);
      info.appendChild(name);
      var meta = document.createElement('div');
      meta.className = 'chatbot-cart-item-meta';
      var stock = p.available ? '✅' : '❌';
      meta.textContent = parseFloat(p.price).toFixed(2) + ' EUR · ' + stock + ' · ' + (p.totalInventory || 0) + ' ' + t.units;
      info.appendChild(meta);
      row.appendChild(info);
      container.appendChild(row);
    });

    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Return Card ───
  function renderReturnCard(ret) {
    if (!ret) return;
    var container = document.createElement('div');
    container.className = 'chatbot-cart';
    var header = document.createElement('div');
    header.className = 'chatbot-cart-header';
    header.textContent = t.returnTitle + ' — ' + ret.orderName;
    container.appendChild(header);
    var row = document.createElement('div');
    row.className = 'chatbot-cart-item';
    var info = document.createElement('div');
    info.className = 'chatbot-cart-item-info';
    var name = document.createElement('div');
    name.className = 'chatbot-cart-item-name';
    name.textContent = 'Status: ' + ret.status;
    info.appendChild(name);
    var meta = document.createElement('div');
    meta.className = 'chatbot-cart-item-meta';
    meta.textContent = ret.message;
    meta.style.whiteSpace = 'normal';
    info.appendChild(meta);
    row.appendChild(info);
    container.appendChild(row);
    messagesInner.appendChild(container);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ─── Checkout Sidebar ───

  function showCheckout() {
    refreshCart();
    checkoutPanel.classList.add('is-visible');
  }

  function hideCheckout() {
    checkoutPanel.classList.remove('is-visible');
  }

  function updateCheckoutPanel(cart) {
    var itemsEl = document.getElementById('ChatbotCheckoutItems');
    var totalEl = document.getElementById('ChatbotCheckoutTotal');
    var linkEl = document.getElementById('ChatbotCheckoutLink');

    while (itemsEl.firstChild) itemsEl.removeChild(itemsEl.firstChild);

    if (cart.items) {
      cart.items.forEach(function (item) {
        var div = document.createElement('div');
        div.className = 'chatbot-checkout-item';

        var nameSpan = document.createElement('span');
        nameSpan.textContent = item.title + ' x' + item.quantity;
        div.appendChild(nameSpan);

        var priceSpan = document.createElement('span');
        priceSpan.textContent = (item.final_line_price / 100).toFixed(2) + ' EUR';
        div.appendChild(priceSpan);

        itemsEl.appendChild(div);
      });
    }

    while (totalEl.firstChild) totalEl.removeChild(totalEl.firstChild);
    var totalLabel = document.createElement('span');
    totalLabel.textContent = t.total;
    totalEl.appendChild(totalLabel);
    var totalValue = document.createElement('span');
    totalValue.textContent = ((cart.total_price || 0) / 100).toFixed(2) + ' EUR';
    totalEl.appendChild(totalValue);

    linkEl.href = '/checkout';
  }

  // ─── Chat UI ───

  function clearMessages() {
    if (messagesInner) {
      while (messagesInner.firstChild) messagesInner.removeChild(messagesInner.firstChild);
    }
  }

  function appendMessage(role, text) {
    var div = document.createElement('div');
    div.className = 'chatbot-msg chatbot-msg--' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') {
      div.textContent = text;
    } else {
      div.innerHTML = formatBotMessage(text);
    }
    messagesInner.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function activityLocale(es, en) {
    return String(lang || LOCALE || '').toLowerCase().indexOf('es') === 0 ? es : en;
  }

  function toolActivityMeta(data) {
    var tool = data && data.tool ? String(data.tool) : '';
    var map = {
      show_product: ['🔎', activityLocale('Cargando producto', 'Loading product')],
      show_collection: ['🗂️', activityLocale('Abriendo coleccion', 'Opening collection')],
      compare_products: ['⚖️', activityLocale('Comparando productos', 'Comparing products')],
      add_to_cart: ['🛒', activityLocale('Anadiendo al carrito', 'Adding to cart')],
      show_cart: ['🛒', activityLocale('Revisando carrito', 'Checking cart')],
      update_cart: ['🛒', activityLocale('Actualizando carrito', 'Updating cart')],
      clear_cart: ['🛒', activityLocale('Vaciando carrito', 'Clearing cart')],
      show_checkout: ['💳', activityLocale('Preparando checkout', 'Preparing checkout')],
      show_orders: ['📦', activityLocale('Consultando pedidos', 'Checking orders')],
      show_order_status: ['📦', activityLocale('Consultando seguimiento', 'Checking tracking')],
      show_shipping: ['🚚', activityLocale('Consultando envios', 'Checking shipping')],
      show_discounts: ['🏷️', activityLocale('Buscando descuentos', 'Checking discounts')],
      apply_discount: ['🏷️', activityLocale('Aplicando descuento', 'Applying discount')],
      create_return: ['↩️', activityLocale('Preparando devolucion', 'Preparing return')],
      show_return_status: ['↩️', activityLocale('Consultando devolucion', 'Checking return')],
      show_wishlist: ['♡', activityLocale('Revisando favoritos', 'Checking wishlist')],
      add_to_wishlist: ['♡', activityLocale('Guardando favorito', 'Saving wishlist item')],
      remove_from_wishlist: ['♡', activityLocale('Quitando favorito', 'Removing wishlist item')],
      list_stock_alerts: ['🔔', activityLocale('Revisando alertas de stock', 'Checking stock alerts')],
      subscribe_stock: ['🔔', activityLocale('Activando alerta de stock', 'Creating stock alert')],
      cancel_stock_alert: ['🔔', activityLocale('Cancelando alerta de stock', 'Cancelling stock alert')],
      submit_suggestion: ['✎', activityLocale('Registrando sugerencia', 'Saving suggestion')],
    };
    var meta = map[tool] || ['⚙️', activityLocale('Ejecutando herramienta', 'Running tool')];
    return { type: 'action', text: meta[1], icon: meta[0], stage: 'tool_call', tool: tool };
  }

  function activityIcon(data) {
    var icon = data && data.icon ? String(data.icon) : '';
    var named = {
      brain: '✦',
      search: '🔎',
      product: '📦',
      cart: '🛒',
      shipping: '🚚',
      order: '📦',
      discount: '🏷️',
      tool: '⚙️',
    };
    return named[icon] || icon || '⚙️';
  }

  function sanitizeActivityLabel(text) {
    var internalName = new RegExp('\\b' + ['Open', 'Claw'].join('') + '\\b', 'gi');
    var cleaned = String(text || '')
      .replace(internalName, '')
      .replace(/\s+([.?!])/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return cleaned || activityLocale('Trabajando...', 'Working...');
  }

  function appendActivity(container, data, prefix, done, existing) {
    var row = existing || document.createElement('div');
    var labelText = sanitizeActivityLabel((data && (data.text || data.label)) ? String(data.text || data.label) : activityLocale('Trabajando...', 'Working...'));
    if (!existing) {
      row.className = prefix + '-activity';
      var icon = document.createElement('span');
      icon.className = prefix + '-activity-icon';
      row.appendChild(icon);
      var label = document.createElement('span');
      label.className = prefix + '-activity-label';
      row.appendChild(label);
      var status = document.createElement('span');
      status.className = prefix + '-activity-status';
      row.appendChild(status);
      container.appendChild(row);
    }
    row.querySelector('.' + prefix + '-activity-icon').textContent = activityIcon(data);
    row.querySelector('.' + prefix + '-activity-label').textContent = labelText;
    row.dataset.stage = data && data.stage ? String(data.stage) : '';
    row.dataset.tool = data && data.tool ? String(data.tool) : '';
    if (done) markActivityDone(row, prefix);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return row;
  }

  function markActivityDone(row, prefix) {
    if (!row) return;
    row.classList.add('is-done');
    var status = row.querySelector('.' + prefix + '-activity-status');
    if (status) status.textContent = '✓';
  }

  function showTyping() {
    var div = document.createElement('div');
    div.className = 'chatbot-typing';
    div.id = 'ChatbotTyping';
    for (var i = 0; i < 3; i++) {
      div.appendChild(document.createElement('span'));
    }
    messagesInner.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideTyping() {
    var el = document.getElementById('ChatbotTyping');
    if (el) el.remove();
  }

  function showToast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2500);
  }

  // ─── SSE Chat (Streaming) ───

  function sendMessage() {
    var message = inputEl.value.trim();
    if (!message || sending) return;

    sending = true;
    sendBtn.disabled = true;
    inputEl.value = '';

    // Hide welcome, show messages
    hideWelcome();

    appendMessage('user', message);
    showTyping();

    // Fetch real cart data before sending
    fetchCart(function(cart) {
      var cartItems = [];
      if (cart && cart.items && cart.items.length > 0) {
        cartItems = cart.items.map(function(item) {
          return item.title + ' (x' + item.quantity + ', ' + (item.final_line_price / 100).toFixed(2) + ' EUR, key:' + item.key + ')';
        });
      }

      var body = {
        message: message,
        history: chatHistory.slice(-20),
        context: {
          customer: CUSTOMER,
          cartItems: cartItems,
          locale: LOCALE,
        },
      };
      if (currentSessionId) body.sessionId = currentSessionId;

      // State for streaming
      var botTextBubble = null;
      var placeholderBubble = null;
      var botText = '';
      var curProducts = [];
      var curCollections = [];
      var thinkingBubble = null;
      var actionBubble = null;

      fetch(API_URL + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);

        hideTyping();

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';

        function pump() {
          return reader.read().then(function (result) {
            if (result.done) {
              // Stream complete - finalize
              if (curProducts.length > 0) {
                renderProductGrid(curProducts);
              }
              if (curCollections.length > 0) {
                renderCollectionGrid(curCollections);
              }
              if (thinkingBubble && thinkingBubble.parentNode) {
                thinkingBubble.parentNode.removeChild(thinkingBubble);
              }
              if (actionBubble && actionBubble.parentNode) {
                markActivityDone(actionBubble, 'chatbot');
                actionBubble = null;
              }
              if (placeholderBubble && placeholderBubble.parentNode) {
                placeholderBubble.parentNode.removeChild(placeholderBubble);
              }

              chatHistory.push({ role: 'user', content: message });
              chatHistory.push({ role: 'assistant', content: botText || '[products shown]' });

              // Update sidebar title if this was the first message
              updateSidebarTitle();

              sending = false;
              sendBtn.disabled = false;
              inputEl.focus();
              return;
            }

            buffer += decoder.decode(result.value, { stream: true });
            var lines = buffer.split('\n');
            buffer = lines.pop() || '';

            for (var i = 0; i < lines.length; i++) {
              var line = lines[i];
              if (line.indexOf('event: ') === 0) {
                var eventType = line.slice(7).trim();
                i++;
                if (i < lines.length && lines[i].indexOf('data: ') === 0) {
                  var dataStr = lines[i].slice(6);
                  try {
                    var eventData = JSON.parse(dataStr);
                    handleStreamEvent(eventType, eventData);
                  } catch (e) { /* skip malformed */ }
                }
              }
            }

            return pump();
          });
        }

        function handleStreamEvent(eventType, data) {
          if (eventType === 'thinking') {
            if (!thinkingBubble) {
              thinkingBubble = document.createElement('div');
              thinkingBubble.className = 'chatbot-msg chatbot-msg--bot';
              thinkingBubble.style.opacity = '0.6';
              thinkingBubble.style.fontStyle = 'italic';
              thinkingBubble.textContent = data.text || 'Thinking...';
              messagesInner.appendChild(thinkingBubble);
              messagesEl.scrollTop = messagesEl.scrollHeight;
            } else {
              thinkingBubble.textContent = data.text || 'Thinking...';
            }
          } else if (eventType === 'action') {
            if (thinkingBubble && thinkingBubble.parentNode) {
              thinkingBubble.parentNode.removeChild(thinkingBubble);
              thinkingBubble = null;
            }
            actionBubble = appendActivity(messagesInner, data, 'chatbot', false, actionBubble);
          } else if (eventType === 'placeholder') {
            // Fast 9B acknowledgement; replaced by the real answer on first real token.
            if (thinkingBubble && thinkingBubble.parentNode) { thinkingBubble.parentNode.removeChild(thinkingBubble); thinkingBubble = null; }
            if (placeholderBubble && placeholderBubble.parentNode) placeholderBubble.parentNode.removeChild(placeholderBubble);
            placeholderBubble = document.createElement('div');
            placeholderBubble.className = 'chatbot-msg chatbot-msg--bot';
            placeholderBubble.style.opacity = '0.6';
            placeholderBubble.style.fontStyle = 'italic';
            placeholderBubble.textContent = data.text || '';
            messagesInner.appendChild(placeholderBubble);
            messagesEl.scrollTop = messagesEl.scrollHeight;
          } else if (eventType === 'token') {
            if (thinkingBubble && thinkingBubble.parentNode) {
              thinkingBubble.parentNode.removeChild(thinkingBubble);
              thinkingBubble = null;
            }
            if (actionBubble && actionBubble.parentNode) {
              markActivityDone(actionBubble, 'chatbot');
              actionBubble = null;
            }
            if (placeholderBubble && placeholderBubble.parentNode) {
              placeholderBubble.parentNode.removeChild(placeholderBubble);
              placeholderBubble = null;
            }

            if (!botTextBubble) {
              botTextBubble = document.createElement('div');
              botTextBubble.className = 'chatbot-msg chatbot-msg--bot';
              botTextBubble.innerHTML = '';
              messagesInner.appendChild(botTextBubble);
            }

            botText += data.text || '';
            botTextBubble.innerHTML = formatBotMessage(botText);
            messagesEl.scrollTop = messagesEl.scrollHeight;
          } else if (eventType === 'tool_call') {
            if (actionBubble && actionBubble.parentNode) {
              markActivityDone(actionBubble, 'chatbot');
              actionBubble = null;
            }
            markActivityDone(appendActivity(messagesInner, toolActivityMeta(data), 'chatbot', false), 'chatbot');

            if (data.tool === 'show_product') {
              if (curCollections.length > 0) {
                renderCollectionGrid(curCollections);
                curCollections = [];
              }
              curProducts.push(data);
            } else if (data.tool === 'show_collection') {
              if (curProducts.length > 0) {
                renderProductGrid(curProducts);
                curProducts = [];
              }
              curCollections.push(data);
            } else {
              if (curProducts.length > 0) {
                renderProductGrid(curProducts);
                curProducts = [];
              }
              if (curCollections.length > 0) {
                renderCollectionGrid(curCollections);
                curCollections = [];
              }
              handleToolCall(data);
            }
          } else if (eventType === 'error') {
            if (thinkingBubble && thinkingBubble.parentNode) {
              thinkingBubble.parentNode.removeChild(thinkingBubble);
            }
            if (actionBubble && actionBubble.parentNode) {
              markActivityDone(actionBubble, 'chatbot');
              actionBubble = null;
            }
            appendMessage('bot', data.message || 'Error.');
          }
        }

        return pump();
      })
      .catch(function (err) {
        hideTyping();
        if (thinkingBubble && thinkingBubble.parentNode) {
          thinkingBubble.parentNode.removeChild(thinkingBubble);
        }
        if (actionBubble && actionBubble.parentNode) {
          markActivityDone(actionBubble, 'chatbot');
          actionBubble = null;
        }
        appendMessage('bot', t.serviceError);
        console.error('Chatbot error:', err);
        sending = false;
        sendBtn.disabled = false;
      });
    }); // end fetchCart callback
  }

  function updateSidebarTitle() {
    if (!currentSessionId || !sessions.length) return;
    // Refresh session list to get updated title from backend
    apiListSessions().then(function (list) {
      sessions = list;
      renderSidebar();
    });
  }

  // ─── Tool Handler (non-product actions) ───

  function handleToolCall(data) {
    switch (data.tool) {
      case 'add_to_cart':
        if (data.product && data.product.variantId) {
          addToCart(data.product.variantId);
        } else if (data.handle) {
          showToast(t.addedToCart);
        }
        break;
      case 'show_checkout':
        showCheckout();
        break;
      case 'show_orders':
        if (data.orders && data.orders.length > 0) {
          renderOrderList(data.orders);
        } else {
          appendMessage('bot', t.noOrders);
        }
        break;
      case 'show_order_status':
        if (data.order) {
          messagesInner.appendChild(renderOrderCard(data.order));
          messagesEl.scrollTop = messagesEl.scrollHeight;
        }
        break;
      case 'submit_suggestion':
        if (data.handle === 'ok') {
          showToast(t.suggestionOk);
        } else {
          showToast(t.suggestionError);
        }
        break;
      case 'show_cart':
        fetchCart(function(cart) { renderCartCard(cart); });
        break;
      case 'update_cart':
        if (data.handle) {
          var cartParts = data.handle.split(':');
          var cVid = cartParts[0], cQty = parseInt(cartParts[1] || '0', 10);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cVid, quantity: cQty }),
          }).then(function() {
            showToast(cQty === 0 ? t.removeFromCart : t.cartUpdated);
            fetchCart(function(cart) { renderCartCard(cart); });
          });
        }
        break;
      case 'clear_cart':
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
          .then(function() {
            showToast(t.cartCleared);
            appendMessage('bot', t.cartCleared);
          });
        break;
      case 'show_wishlist':
        if (data.wishlistItems) renderWishlistCard(data.wishlistItems);
        break;
      case 'add_to_wishlist':
        if (data.success) showToast(t.savedToWishlist);
        break;
      case 'remove_from_wishlist':
        if (data.success) showToast(t.removedFromWishlist);
        break;
      case 'list_stock_alerts':
        if (data.stockAlerts) renderStockAlerts(data.stockAlerts);
        break;
      case 'subscribe_stock':
        if (data.success) showToast(t.alertActivated);
        break;
      case 'cancel_stock_alert':
        if (data.success) showToast(t.alertCancelled);
        break;
      case 'show_shipping':
        if (data.shippingMethods) renderShippingCard(data.shippingMethods, data.handle);
        break;
      case 'show_discounts':
        if (data.discounts) renderDiscountCard(data.discounts);
        break;
      case 'apply_discount':
        if (data.handle) window.location.href = '/discount/' + data.handle;
        break;
      case 'compare_products':
        if (data.comparisonProducts) renderComparisonCard(data.comparisonProducts);
        break;
      case 'create_return':
        if (data.returnData) renderReturnCard(data.returnData);
        break;
      case 'show_return_status':
        if (data.returnData) renderReturnCard(data.returnData);
        break;
    }
  }

  // ─── Initialization ───

  function init() {
    // Check for session handoff from widget (?session=xxx)
    var urlParams = new URLSearchParams(window.location.search);
    var sessionFromUrl = urlParams.get('session');

    if (CUSTOMER && CUSTOMER.email) {
      // Logged-in: load sessions from backend
      apiListSessions().then(function (list) {
        sessions = list;
        if (sessionFromUrl) {
          // Handoff from widget — load that session
          switchSession(sessionFromUrl);
          window.history.replaceState({}, '', window.location.pathname);
        } else if (sessions.length > 0) {
          // Switch to most recent session
          switchSession(sessions[0].id);
        } else {
          // Create first session
          createNewSession();
        }
        renderSidebar();
      });
    } else {
      // Anonymous: show welcome screen, no sessions
      showWelcome();
    }
  }

  // ─── Event Listeners ───

  sendBtn.addEventListener('click', sendMessage);
  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') sendMessage();
  });

  // ─── Public API ───
  window.SkirmChatbot = {
    hideCheckout: hideCheckout,
    showCheckout: showCheckout,
  };

  // Start
  init();
})();
